import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, from, switchMap } from 'rxjs';

import { environment } from '../../../environments/environment';
import { CalTokenService } from '../services/cal-token.service';

const GRAPH_ALLOWED_HOSTS = new Set<string>([
  'graph.microsoft.com',
]);

function isMicrosoftGraphRequest(urlStr: string): boolean {
  try {
    const url = new URL(urlStr, window.location.origin);
    return url.protocol === 'https:' && GRAPH_ALLOWED_HOSTS.has(url.hostname);
  } catch {
    return false;
  }
}

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  if (req.headers.has('Authorization')) {
    return next(req);
  }

  if (isMicrosoftGraphRequest(req.url)) {
    return next(req);
  }

  const calTokenService = inject(CalTokenService);
  const apiScope = `${environment.apiScope}/user_impersonation`;

  return from(calTokenService.getAccessToken([apiScope])).pipe(
    switchMap((accessToken) => {
      if (!accessToken) {
        return next(req);
      }
      const authenticatedRequest = req.clone({
        setHeaders: { Authorization: `Bearer ${accessToken}` }
      });
      return next(authenticatedRequest);
    }),
    catchError(() => next(req))
  );
}
